export default __webpack_public_path__ + "static/media/logo-tem-saude.800c7066.png";